import * as React from 'react';

const CancelCircle24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h24v24H0z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16.53 8.53 13.06 12l3.47 3.47-1.06 1.06L12 13.06l-3.47 3.47-1.06-1.06L10.94 12 7.47 8.53l1.06-1.06L12 10.94l3.47-3.47 1.06 1.06zM12 20.5c-4.687 0-8.5-3.814-8.5-8.5 0-4.687 3.813-8.5 8.5-8.5 4.687 0 8.5 3.813 8.5 8.5 0 4.686-3.813 8.5-8.5 8.5zM12 2C6.477 2 2 6.477 2 12c0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10z"
  }
)));
CancelCircle24.Size = 24;
CancelCircle24.Title = "CancelCircle";

export { CancelCircle24 as default };
